export default {
  label_en: 'HOW WE WORK',
  title: 'How We Support AI Adoption',
  intro: 'From the first conversation to full adoption, we typically walk alongside you in five steps. Nothing has to happen all at once - we validate small, confirm, then expand. For service-specific processes, see each service page.',
  steps: [
    {
      no: '01',
      title: 'Consultation & Problem Framing',
      badge: 'Free',
      desc: 'We verbalize your current operations and challenges through interviews. It is fine to start from "we don\'t know where to begin."',
      caseIds: []
    },
    {
      no: '02',
      title: 'Assessment & Visualization',
      badge: '',
      desc: 'Using tools such as our AI Readiness Assessment, we visualize your organization\'s current position in numbers and charts, and prioritize initiatives.',
      caseIds: [7]
    },
    {
      no: '03',
      title: 'PoC — Validate Small',
      badge: '',
      desc: 'We narrow down to high-impact work and validate feasibility and effect at minimum scope, giving you decision material before major investment.',
      caseIds: [5, 4]
    },
    {
      no: '04',
      title: 'Full Implementation',
      badge: '',
      desc: 'We build the validated mechanism into a production system and integrate it into frontline workflows, meeting security requirements.',
      caseIds: [1, 2]
    },
    {
      no: '05',
      title: 'Adoption & In-house Enablement',
      badge: '',
      desc: 'Training and hands-on support build an organization that truly uses AI — through to in-house capability to improve on your own.',
      caseIds: [3, 8]
    }
  ]
};
